import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of, BehaviorSubject, Subject, from } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
declare var window: any;
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

export interface ResourcePermission {
  ResourceName: string,
  CanSearch: boolean,
  CanCreate: boolean,
  CanUpdate: boolean,
  CanDelete: boolean
}

@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor() {
  }

  /** for sidebar **/
  private UserMenu: any[];
  menuSubject = new BehaviorSubject<any[]>(null);
  currentMenu = this.menuSubject.asObservable();
  SetMenu(menus) {
    this.UserMenu = menus;
    this.menuSubject.next(menus);
  }

  GetMenu() {
    return this.UserMenu;
  }
  /** for sidebar end **/

  /** for user permission **/
  private userPermission = new BehaviorSubject<ResourcePermission>({ ResourceName: '', CanSearch: true, CanCreate: true, CanUpdate: true, CanDelete: true });
  currentResource = this.userPermission.asObservable();

  SetResourcePermission(resourceName: string, resource: any[]) {
    let rp: ResourcePermission = { ResourceName: resourceName, CanSearch: false, CanCreate: false, CanUpdate: false, CanDelete: false };

    if (resource?.length) {
      for (const item of resource) {

        switch (item.ActionName) {
          case "Search":
            rp.CanSearch = item.Enabled;
            break;
          case "Create":
            rp.CanCreate = item.Enabled;
            break;
          case "Update":
            rp.CanUpdate = item.Enabled;
            break;
          case "Delete":
            rp.CanDelete = item.Enabled;
            break;
          default:
            break;
        }
      }
    }
    this.userPermission.next(rp);

  }
  /** for user permission end**/

  /** for loading **/
  private loadingSource = new Subject();
  loadingObservable = this.loadingSource.asObservable();

  SetLoadingState(loading: boolean) {
    this.loadingSource.next(loading);
  }
  /** for loading end **/


  /** for pass error message  **/
  private ErrorMessage = new BehaviorSubject<string>('');
  ErrMsg = this.ErrorMessage.asObservable();

  /** setting error message
   * @param msg: string display
   */
  SetErrMsg(msg: string) {
    this.ErrorMessage.next(msg);
  }
  /** for pass error message end **/

  /** for Front-end settings **/
  public Init() {
    return from(
      fetch('assets/Front-end settings.json').then(function (response) {
        return response.json();
      })
    ).pipe(
      map((config) => {
        window.config = config;
        return
      })).toPromise();
  }

  /** for Front-end settings end **/
}
